import React from 'react'
import { Outlet } from 'react-router-dom';
import NavBar from '../components/NavBar';
import { UserProvider } from '../context/UserData';
import { BookmarksProvider } from '../context/Bookmarks';


const MainLayout = () => {
  return (
    <>
    <UserProvider>
    <BookmarksProvider>
      <NavBar />
      <Outlet />
    </BookmarksProvider>
    </UserProvider>
    </>
  )
}

export default MainLayout